import {Button, CircularProgress, Dialog} from "@mui/material";
import React, {useEffect, useState} from "react";
import DialogContent from "@mui/material/DialogContent";
import {useMutationCoordinate} from "../../clients/graphql/graphql.hooks";
import Typography from "@mui/material/Typography";
import {
    JediAutoPilotSettingsUndoDeleteMutation,
} from "../../clients/graphql/components/buttons-queries";

export default function RestorePilot({ autoPilotSettingsKey } : { autoPilotSettingsKey: number }) {

    const [errorMessage, setErrorMessage] = useState<string | null>(null);
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [dialogContent, setDialogContent] = useState<'loading' | 'success' | 'error' | null>(null);

    const [undoDeleteMutation, status] = useMutationCoordinate(
        JediAutoPilotSettingsUndoDeleteMutation,
        {
            variables: { autoPilotSettingsKey },
        }
    );

    useEffect(() => {
        const result = status?.data?.jediAutoPilotSettingsUndoDelete;

        if (result) {
            if (result.success) {
                setDialogContent('success');
            } else {
                setDialogContent('error');
                setErrorMessage(result.message || 'Failed to restore pilot. :(');
            }

            setIsDialogOpen(true);
        }
    }, [status?.data]);

    return (
        <div>
            <Button
                variant="outlined"
                color={'primary'}
                onClick={() => {
                    setDialogContent('loading');
                    setErrorMessage(null);
                    setIsDialogOpen(true);
                    undoDeleteMutation();
                }}
                size={'small'}>
                Restore Pilot
            </Button>

            <Dialog
                open={isDialogOpen}
                onClose={() => setIsDialogOpen(false)}
            >
                <DialogContent>
                    {dialogContent === "loading" && (<CircularProgress size={60} sx={{display: 'flex', justifySelf: 'center', alignSelf: 'center', margin: 'auto'}}/>)}

                    {dialogContent === "error" && (<Typography> {errorMessage} </Typography>)}

                    {dialogContent === "success" && (<Typography> Pilot Successfully Restored :) </Typography>)}
                </DialogContent>
            </Dialog>
        </div>
    );
}